import React from "react";
import CTAButton from "../CTAButton/CTAButton";
import "./Automation.css";
import { Link } from "react-router-dom";
import automationflow from "../../assets/automation flow.png";
import automation_welcome from "../../assets/welcome.png";
import automation_Journey from "../../assets/automation Journey.png";
import automation_Autopilot from "../../assets/Automation Autopilot.png";
import aiFallback from "../../assets/ai-section-fallback.png";
import marketingalternative from "../../assets/new/Marketing Automation That Saves Time and Increases Productivity mailsnappy.png";



const Automation = () => {
  return (
    <div className="automation-page">
      {/* HERO SECTION */}
      <section className="automation-hero">
        <div className="hero-left">
          <Link to="/features" className="back-link">← Back to features</Link>
          <h1>Email Marketing Automation That Works for Your Business</h1>
          <p>
            Grow your business with email marketing automation that keeps every subscriber engaged from the moment they join your email list. MailSnappy helps you create automated email workflows that welcome new subscribers, nurture leads, deliver personalized email campaigns, and strengthen customer relationships. Save time by automating repetitive tasks while ensuring every subscriber receives the right message at the right stage of their journey.
          </p>
          <p>
            Pair automation with <Link className="linkcolor" to="/segmentation">audience segmentation</Link> and reusable <Link className="linkcolor" to="/templates">email templates</Link> to build more relevant journeys from the start.
          </p>
          <div className="hero-form"><CTAButton>Get started</CTAButton></div>
        </div>

        <div className="hero-right">
           <img src={automationflow} alt="Email automation workflow preview" width="640" height="420" />
        </div>
      </section>

      {/* DELIVER WELCOME */}
      <section className="automation-section">
        <div className="section-left">
          <img src={automation_welcome} alt="Automated welcome email sequence preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="section-right">
          <h2>Welcome New Subscribers with Automated Email Sequences</h2>
          <p>
            Create a memorable first impression with automated welcome email sequences that introduce your brand, build trust, and encourage meaningful engagement. Reach subscribers while their interest is at its highest and guide them toward your products, services, or latest offers with personalized email marketing that feels timely and relevant.
          </p>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="testimonial">
        <div className="testimonial-container">
          <div className="testimonial-text">
            <p>
              “We’ve gone from basically nothing to doing close to $20k per month
              in just over a year — all powered by email.”
            </p>
            <p className="author">– Tom Hunt, SaaS Marketer</p>
          </div>
          <img src={aiFallback} alt="Automation customer testimonial avatar" className="testimonial-img" width="96" height="96" loading="lazy" />
        </div>
      </section>

      {/* AUTOMATION JOURNEY */}
      <section className="automation-section reverse">
        <div className="section-left">
          <img src={automation_Journey} alt="Subscriber journey automation preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="section-right">
          <h2>Guide Subscribers Through Automated Customer Journeys</h2>
          <p>
            Create a memorable first impression with automated welcome email sequences that introduce your brand, build trust, and encourage meaningful engagement. Reach subscribers while their interest is at its highest and guide them toward your products, services, or latest offers with personalized email marketing that feels timely and relevant.
          </p>
          <CTAButton className="primary-btn" kind="automation">Open automation builder</CTAButton>
        </div>
      </section>

      {/* AUTOPILOT SECTION */}
      <section className="automation-section">
        <div className="section-left">
          <h2>Customer Journey Automation That Builds Lasting Relationships</h2>
          <p>
            Design customer journey automation that educates, nurtures, and converts subscribers with ease. Create flexible email workflows based on subscriber actions, interests, and behavior to deliver relevant content at every stage. MailSnappy helps you build stronger relationships while increasing engagement, conversions, and long term customer loyalty.
          </p>
        </div>
        <div className="section-right">
          <img src={automation_Autopilot} alt="Marketing automation autopilot preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      <section className="automation-section">
        <div className="section-left">
          <h2>Marketing Automation That Saves Time and Increases Productivity</h2>
          <p>
Automate your email marketing once and let MailSnappy do the rest. Schedule campaigns, trigger automated emails, and manage subscriber communication without manual effort. By streamlining your marketing automation, you can focus on growing your business while delivering consistent and engaging email experiences that drive better results.          </p>
          <p>
            If you are planning broader sends, explore our <Link className="linkcolor" to="/email-campaign-software">email campaign software</Link> page for the full campaign workflow.
          </p>
        </div>
        <div className="section-right">
          <img src={marketingalternative} alt="Productivity-focused email automation preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>
          Sign up and send your first campaign in minutes. No credit card required.
        </p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Automation;
